import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import SegmentProof from "./SegmentProof";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Chip } from "@mui/material";
import verified from "../../assets/check-mark.png"
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { Checkbox } from "primereact/checkbox";

const SegmentDetails = ({ msg }) => {
  const userCode = sessionStorage.getItem("userCode");
  const URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [docType, setDockType] = useState("");
  const [segmentFile, setSegmentFile] = useState('');
  const [check, setCheck] = useState(false);
  const [segment, setSegment] = useState("");
  const [activeSegment, setActiveSegment] = useState("")
  const [segError, setSegError] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [segmentPreview, setSegmentPreview] = useState("");
  const [isAuth, setAuth] = useState(sessionStorage.getItem("userCode"));
  const [segmentName, setSegmentName] = useState('')
  const [error, setError] = useState("");
  

  const documentType = [
    {
      label: "Last 6 months Bank Statement",
      value: "LAST-SIX-MONTHS-BANK-STATEMENT",
    },
    { label: "Latest Salary Slip",
     value: "LATEST-SALARY-SLIP" 
    },
    { label: "Latest Form 16",
     value: "LATEST-FORM-16" 
    },
    {
      label: "Latest ITR Acknowledgement",
      value: "LATEST-ITR-ACKNOWLEDGE",
    },
    {
      label: "Latest Holding Statement with Value",
      value: "LATEST-HOLDING-STATEMENT-WITH-VALUE",
    },
  ];
  
  const delSegmentProofData = async () => {
    try {
      await axios.post(`${URL}/SegmentDetail/removeSegmentProof`, {
        userCode: userCode,
      });
    } catch (error) {
      console.log("error in segment data", error);
    }
  };

  const getSegmentData = async () => {
    try {
      const response = await axios.post(
        `${URL}/SegmentDetail/getSegmentDetails`,
        {
          userCode: userCode,
        }, { withCredentials: true }
      );
      setSegment(response.data.data);
      setSegmentFile("");
    } catch (error) {
      setActiveSegment(error?.response?.data?.result?.flagMsg)
      // console.log("error in segment data", error.response.data.result.flagMsg);
    }
  };

  const getSegmentProofData = async () => {
    try {
      const response = await axios.post(`${URL}/SegmentDetail/previewSegment`, {
        userCode: userCode,
      }, { withCredentials: true });
      setSegmentPreview(response.data.data.proofPath);
      setSegmentName(response.data.data.proofName)
    } catch (error) {
      console.log("error in segment data", error);
    }
  };

  useEffect(() => {
    getSegmentData();
    // getSegmentProofData();
  }, []);

  useEffect(() => {
    if (isAuth) {
      navigate("/segment");
    } else {
      navigate("/");
    }
  }, []);

  // useEffect(() => {
  //   if(check == false){
  //     delSegmentProofData();
  //   }
  // },[])

  // const segmentSubmit = async (event) => {
  //   setShowMessage(true);
  //   await getSegmentProofData();
  // };

  const onValueChange = (e) => {
    setDockType(e.target.value);
    setSegError("");
  };

  const closePopUp = () => {
    setShowMessage(false);
    getSegmentProofData()
    navigate("/esign");
  };

  const onConfirm = async() => {
    try {
      var myHeaders = new Headers();
        const response = await axios({
          method: "post",
          url: `${URL}/SegmentDetail/saveSegmentProof`,
          headers: myHeaders,
          data: segmentFile,
          withCredentials: true
        });
        // setBUpload(response);
        setError("");
        setShowMessage(true)
      } catch (error) {
        // console.log("error in segment data", error.response?.data?.result?.flagMsg);
        setError(error?.response?.data?.result?.flagMsg)
      }
  }

  const dialogFooter = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={closePopUp}
      />
    </div>
  );

  return (
    <>
      <Dialog
        visible={showMessage}
        onHide={() => setShowMessage(false)}
        position="top"
        footer={dialogFooter}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-check-circle"
            style={{ fontSize: "3rem", color: "var(--green-500)" }}
          ></i>
          <h5 className="c_pop">Details Saved Successfully!</h5>
        </div>
      </Dialog>
      <Card
        style={{
          margin: "0.5em 2em 2em 2em",
          padding: "1em",
          borderRadius: 20,
        }}
      >
        <div className="line">
          <h2>
          Segment details<span style={{fontSize: 14,position: 'relative',top: '-4px'}}> (optional)</span>
          </h2>
          <div>
              {msg.segmentDetailStatus == "VERIFIED" ?    <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<img src={verified} alt='verify' width='25px' />} label={msg.segmentDetailStatus}  variant="outlined" sx={{background: '#0080004f'}} />
              </div>: msg.segmentDetailStatus == "PENDING" ?    <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<HourglassTopIcon />} label={msg.segmentDetailStatus}  variant="outlined" sx={{background: '#d3d3436b'}} />
              
              
            
            </div> : msg.segmentDetailStatus == "REJECTED" ?   <div
            style={{
              fontSize: 12,
              color:'red',
              float: "right",
              marginTop: 20,
              display:'contents'
            }}
          >{msg.segmentDetailRemarks}</div> : null}
            </div>
          <hr />
        </div>

        <div className="mobile">
          <div className="mobile_form_1">
            <label>
              Document Type<sup>*</sup>
            </label>
            <Dropdown
              className={
                segError ? "p-inputtext-sm p-invalid" : "p-inputtext-sm"
              }
              value={docType}
              options={documentType}
              placeholder={"Select Document Type"}
              onChange={onValueChange}
              disabled={msg.segmentDetailStatus == "VERIFIED" || msg.segmentDetailStatus == "PENDING" || msg.esignDetailStatus == "VERIFIED" || msg.esignDetailStatus == "PENDING" }
            />
            {segError ? (
              <span style={{ color: "red", fontSize: 12, marginTop: "-25px" }}>
                {segError}
              </span>
            ) : null}
            <label>
            Income Proof{" "}
              <span className="act">
                (Only jpg, png, pdf and size 10MB Max)<sup>*</sup>
              </span>
            </label>
            <SegmentProof
              msg={msg}
              activeSegment={activeSegment}
              setSegmentFile={setSegmentFile}
              segmentFile={segmentFile}
              docType={docType}
              setSegError={setSegError}
              getSegmentProofData={getSegmentProofData}
              segmentPreview={segmentPreview}
              setSegmentPreview={setSegmentPreview}
              segmentName={segmentName}
              setSegmentName={setSegmentName}
            />
            <i 
                    className="custom-target-icon pi pi-info-circle ml-2" 
                    style={{ fontSize: '1rem', position: 'relative', top: '-70px' }} 
                    // onClick={openTcDialog}
                    >  </i>
                    <span style={{fontFamily:'Roboto', position: 'relative', paddingRight: 20, top: '-122px', left: 28, fontSize: '0.80rem', color: '#979797'}}> Dear client, once the segment is filled and submitted, you would not be able to 
                      withdraw or opt out of Segment. For more details, please contact customer care at <span style={{fontWeight: 'bold'}}>crf@stoxkart.com</span></span>
            <div className="check_segmenet">
            <div className="field-checkbox">
                    <Checkbox 
                    name="isIndianCitizen"
              checked={segmentFile || msg.segmentDetailStatus == 'VERIFIED' || msg.segmentDetailStatus == 'PENDING' ? true : check}
              // value={isIndianCitizen}
              onChange={(e) => {
                setCheck(e.target.checked);
              }}
              disabled
                    />
                    <label htmlFor="binary">I want to Activate Derivative Segments</label>
                </div>
              {/* <div className="check">
                <input
                  className="styled-checkbox"
                  id="styled-checkbox-1"
                  type="checkbox"
                  onChange={(e) => {
                    setCheck(e.target.checked);
                  }}
                  checked={segmentFile ? true : check }
                  style={{ width: "15px", height: "15px" }}
                />
                
                <span className="activate" style={{fontSize: '1rem'}}>
                I want to Activate Derivative Segments
                </span>
              </div> */}
            </div>
          </div>

          {error ? <span style={{color: 'red', fontSize: 10}}>{error}</span> : null}
           
          <Button
            disabled={
              // segmentPreview != '' ||
              segmentFile == '' 
              || msg.segmentDetailStatus == "VERIFIED"
              || msg.segmentDetailStatus == "PENDING"
              || msg.esignDetailStatus == "VERIFIED"
              || msg.esignDetailStatus == "PENDING"
            }
            label="Confirm"
            onClick={onConfirm}
            className="p-button-raised mr-3 p-button-sm smc_color res_btn"
          />
        </div>
      </Card>
    </>
  );
};

export default SegmentDetails;
